module.exports = __webpack_public_path__ + "static/media/biaacc_body.61b898a3.jpg";